// Скрипт валидации для WordPress
// import {modals} from '../modal/init-modals';
import {modals} from '../../modal/init-modals';

export class Validation {
  constructor() {
    this._modals = modals;
    this._forms = document.querySelectorAll('[data-validation]');

    this._timeoutId = null;

    this._namespace = 'my-app/v1';

    this._onSubmitForm = this._onSubmitForm.bind(this);

    this._emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;

    this._errors = new Set();
  }

  init() {
    if (!this._forms.length || !window.smartCaptcha) {
      return;
    }

    this._forms.forEach((form) => {
      const widget = form.querySelector('[data-validation-widget]');
      if (!widget) {
        return;
      }
      const widgetId = window.smartCaptcha.render(widget, {
        sitekey: 'ysc1_Qa7oqgOWbkWb32X0vKOCm6rZuecTNe4jy6t5AoZl415354b4',
        invisible: true,
      });

      widget.setAttribute('data-validation-widget', widgetId);

      form.addEventListener('submit', this._onSubmitForm);
    });
  }

  async _getToken(widgetId) {
    const response = window.smartCaptcha.getResponse(widgetId);

    if (response) {
      window.smartCaptcha.reset(widgetId);
    }

    const token = await window.smartCaptcha.executePromise(widgetId);

    return token;
  }

  async _onSubmitForm(evt) {
    evt.preventDefault();

    const form = evt.target;

    const widget = form.querySelector('[data-validation-widget]');

    if (!widget) {
      return Promise.reject('Не найден контейнер капчи');
    }
    const widgetId = widget.dataset.validationWidget;
    const errors = form.querySelector('[data-validation-errors]');

    errors.innerHTML = '';

    this._validateForm(form);

    if (this._errors.size) {
      this._setErrors(errors);
      return;
    }
    let token = '';
    try {
      token = await this._getToken(widgetId);
    } catch(error) {
      errors.innerHTML = this._createError(error.message || 'Не удалось пройти проверку капчи');
      return;
    }
    const formType = form.dataset.formType || 'question';
    const formData = new FormData(form);
    formData.append('type', formType);
    formData.append('token', token);
    this._sendFeedback(form, formData);
  }

  async _sendFeedback(form, formData) {
    try {
      const response = await fetch(`${wpApiSettings.root}${this._namespace}/request/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-WP-Nonce': wpApiSettings.nonce
        },
        body: this._formDataToJson(formData),
      });

      const result = await response.json();

      this._showMessage(form, result);
    } catch (err) {
      console.log('Error: ' + err);
    }
  }

  _showMessage(form, result) {
    const errors = form.querySelector('[data-validation-errors]');

    errors.innerHTML = '';

    if (result.success) {
      if (form.closest('[data-modal]')) {
        const modal = document.querySelector('[data-modal].is-active');

        if (modal) {
          this._modals.close(modal.dataset.modal);
        }

        if (this._timeoutId) {
          clearTimeout(this._timeoutId);
        }
      }

      this._modals.open('modal-success');

      this._timeoutId = setTimeout(() => {
        if (document.querySelector('[data-modal="modal-success"].is-active')) {
          this._modals.close('modal-success');
        }
      }, 3000);

      form.reset();
    } else {
      let errorResult = '';
      let errorsList = result.errors || ['Произошла ошибка, попробуйте позже'];
      errorsList.forEach((error) => {
        errorResult += this._createError(error);
      });
      errors.innerHTML = errorResult;
    }
  }

  _validateForm(form) {
    this._errors.clear();

    const fields = form.querySelectorAll('[data-validation-type]');

    fields.forEach((field) => {
      const type = field.dataset.validationType;

      switch (type) {
        case 'text':
          this._validateTextField(field);
          break;
        case 'phone':
          this._validatePhoneField(field);
          break;
        case 'email':
          this._validateEmailField(field);
          break;
        case 'select':
          this._validateSelectField(field);
          break;
        case 'checkbox':
          this._validateCheckboxField(field);
          break;
      }
    });
  }

  _validateTextField(field) {
    const input = field.querySelector('input');
    if (!input.value) {
      field.classList.add('is-error');
      this._errors.add('required');
    } else {
      field.classList.remove('is-error');
    }
  }

  _validatePhoneField(field) {
    const input = field.querySelector('input');
    if (!input.value) {
      field.classList.add('is-error');
      this._errors.add('required');
    } else if (input.value.length < 18) {
      field.classList.add('is-error');
      this._errors.add('phone');
    } else {
      field.classList.remove('is-error');
    }
  }

  _validateEmailField(field) {
    const input = field.querySelector('input');
    if (!input.value) {
      field.classList.add('is-error');
      this._errors.add('required');
    } else if (input.value && !this._emailRegex.test(input.value)) {
      field.classList.add('is-error');
      this._errors.add('email');
    } else {
      field.classList.remove('is-error');
    }
  }

  _validateSelectField(field) {
    const select = field.querySelector('select');
    if (!select.value) {
      field.classList.add('is-error');
      this._errors.add('required');
    } else {
      field.classList.remove('is-error');
    }
  }

  _validateCheckboxField(field) {
    const input = field.querySelector('input');

    if (!input.checked) {
      field.classList.add('is-error');
      this._errors.add('privacy');
    } else {
      field.classList.remove('is-error');
    }
  }

  _setErrors(element) {
    let result = '';

    this._errors.forEach((error, errorAgain, set) => {
      switch (error) {
        case 'required':
          result += this._createError('Заполните все обязательные поля');
          break;
        case 'phone':
          result += this._createError('Введите пожалуйста корректный номер телефона');
          break;
        case 'email':
          result += this._createError('Введите пожалуйста корректный адрес электронной почты');
          break;
        case 'privacy':
          result += this._createError('Пожалуйста дайте согласие на обработку данных');
          break;
      }
    });

    element.innerHTML = result;
  }

  _createError(text) {
    return `
      <div class="errors__error">
        <span>${text}</span>
      </div>`;
  }

  _formDataToJson(formData) {
    const object = {};

    formData.forEach((value, key) => {
      if (!object.hasOwnProperty(key)) {
        object[key] = value;
      } else {
        if (!Array.isArray(object[key])) {
          object[key] = [object[key]];
        }
        object[key].push(value);
      }
    });

    return JSON.stringify(object);
  }
}
